import React, { memo } from "react";

function MiddleContent() {
  return (
    <div className="peace-mind">
      <div className="container">
        <div className="row m-0 align-items-start">
          <div className="col-md-12">
            <div className="text-center sec-title">
              <h3 className="text-white">PEACE-OF-MIND PROTECTION</h3>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="peace-card">
              <div className="cardimg">
                <img src="/image/icon1.png" alt="freedom" />
              </div>
              <h5>
                FREEDOM <span> to enjoy your purchase</span>
              </h5>
              <p className="text-center">
                Breakdowns happen, don’t let them ruin your day. With a
                ProtectAll in-home service plan, we have you covered
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="peace-card">
              <div className="cardimg">
                <img src="/image/icon2.png" alt="furniture lasts longer" />
              </div>
              <h5>
                PRODUCT <span>lasts longer </span>
              </h5>
              <p className="text-center">
                ProtectAll plans are designed to repair breakdowns as they
                occur, so your product will look newer and last longer.
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="peace-card">
              <div className="cardimg">
                <img src="/image/icon3.png" alt="easy to use" />
              </div>
              <h5>
                EASY<span>to use</span>
              </h5>
              <p className="text-center">
                Our self-service portal lets you manage your plans, file and
                track claims, and connect with an agent all in one place.
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="peace-card">
              <div className="cardimg">
                <img src="/image/icon4.png" alt="saves time and money" />
              </div>
              <h5>
                SAVES <span>time and money</span>
              </h5>
              <p className="text-center">
                Gain access to a nationwide network of expert technicians. If
                they can’t fix it, we’ll replace it — at no extra cost.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(MiddleContent);
